import type { FC } from 'react';
import { useEffect } from 'react';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';

import { prepareEventData } from '../../core/prepare-event-data';

import type { TAnalyticsEventSenderOnMount } from './models';

export const AnalyticsEventSenderOnMount: FC<TAnalyticsEventSenderOnMount> = ({ $event }) => {
    useEffect(() => {
        const eventData = prepareEventData($event);
        sendEvent(eventData);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};
